import React from 'react';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const Tooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} arrow enterDelay={0} leaveDelay={0} />
))({
  [`& .${tooltipClasses.arrow}`]: { color: 'black' },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    fontSize: '13px',
    fontWeight: 600,
    padding: '6px 10px',
    textAlign: 'center'
  }
});

export default Tooltip;
